import { TABLES } from '@/utils/constants';
import { getRecords } from '@/utils/helpers/data';
import { SERVICE_COLUMNS, Service } from '@/utils/schema';
import { supabase } from '@/utils/supabase';

export type { Service };
export const COLUMNS = SERVICE_COLUMNS;

/**
 * Retrieves all services for a specific dentist by the dentist's ID.
 * @param dentistId - The ID of the dentist whose services to retrieve.
 * @returns An array of services for the specified dentist.
 * @throws Will throw an error if the retrieval fails.
 */
export const getServicesByDentistId = async (
  dentistId: string
): Promise<Service[]> => {
  return getRecords<Service>(TABLES.SERVICES, COLUMNS.DENTIST_ID, dentistId);
};

/**
 * Retrieves all default services (services with no specific dentist) from the database.
 * @returns An array of default services.
 * @throws Will throw an error if the retrieval fails.
 */
export const getDefaultServices = async (): Promise<Service[]> => {
  const { data, error } = await supabase
    .from(TABLES.SERVICES)
    .select('*')
    .is(COLUMNS.DENTIST_ID, null);

  if (error) {
    console.error('Error fetching default services:', error);
    throw new Error(error.message);
  }

  return data ?? [];
};
